module.exports = __webpack_public_path__ + "static/media/alexion.99eea9a9.png";